module.exports = "/lucky-balls/img/drum/drum_loop_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_005.png
// module id = 1020
// module chunks = 0